import type { Ref } from 'react';
import { Link } from 'react-router-dom';
import styles from './NoAccessState.module.css';

export interface NoAccessStateProps {
    /** The container, so `RoutePermissionGuard` can find the `<main>` it renders into (F5-k WI-2.2 plan Decision 8). */
    readonly ref?: Ref<HTMLDivElement>;
}

/**
 * What a section route renders, in place, when the session does not hold the route's key (F5-k
 * FR-18) — after a `/me` re-read removed it, or on a deep link to a screen the user never had.
 *
 * A heading, one sentence and a link to the landing page. The sentence names no role and no
 * permission key (design-system §9, *Permission rendering*), and the app does not navigate away on
 * its own. The heading is the page's `h1`, so `PageHeadingFocus` and `RoutePermissionGuard` can move
 * focus to it. No live region: a focus move announces the change (F5-k WI-2.2 plan Decision 8).
 */
export function NoAccessState({ ref }: NoAccessStateProps) {
    return (
        <div ref={ref} className={styles.root} data-testid="app-no-access">
            <h1 className={styles.heading}>No access</h1>
            <p className={styles.sentence}>You don't have access to this page</p>
            <Link to="/" className={styles.link}>
                Back to home
            </Link>
        </div>
    );
}
